module.exports = __webpack_public_path__ + "img/button_hover.2d03f047.png";